module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "title": "Duplicate Report",
      "id": _vm.id,
      "value": _vm.value
    },
    on: {
      "shown": _vm.clear,
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('button', {
          staticClass: "btn green mt-ladda-btn ladda-button duplicate-report-modal-btn",
          attrs: {
            "data-style": "expand-left"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.submitDuplicate.apply(null, arguments)
            }
          }
        }, [_c('span', {
          staticClass: "ladda-label"
        }, [_vm._v("Duplicate Report")])])]
      },
      proxy: true
    }])
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "d-report"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('d-report.name')
    }
  }, [_c('label', {
    attrs: {
      "for": "formname"
    }
  }, [_vm._v("Report Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "formname",
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('d-report.name')),
      expression: "errors.has('d-report.name')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('d-report.name')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('d-report.description')
    }
  }, [_c('label', {
    attrs: {
      "for": "formdesc"
    }
  }, [_vm._v("Report Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "formdesc",
      "name": "description",
      "type": "text"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('d-report.description')),
      expression: "errors.has('d-report.description')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('d-report.description')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65a0d1b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/reports/DuplicateReportModal.vue
// module id = 1675
// module chunks = 1